import EcusNavigator from './EcusNavigator'

export default EcusNavigator
